import moment from "moment";

function removeNullAttributes(object) {
  return Object.fromEntries(
    Object.entries(object).filter(
      ([, v]) => v !== "" && v !== null && v !== undefined
    )
  );
}

function queryStringFromObject(queryObject) {
  return new URLSearchParams(queryObject).toString();
}

function getDataFromToken(token) {
  return JSON.parse(atob(token?.split(".")[1]));
}

function getKeyByValue(object, value) {
  return Object.keys(object).find((key) => object[key] === value);
}

function isObjectEmpty(object) {
  if (object === null) {
    return true;
  }
  return Object.keys(object).length === 0 && object.constructor === Object;
}

function dateDifference(date1, date2, wise) {
  let d1 = moment(date1);
  let d2 = moment(date2);
  let result = d1.diff(d2, wise);
  let diff = Math.sign(result);
  const final = {
    result: Math.ceil(Math.abs(result) / 24),
    isExpired: diff === -1 ? false : true,
    isSame: result === 0 ? true : false,
  };
  return final;
}

function getFirstLetters(value) {
  if (value) {
    let matches = value.match(/\b(\w)/g);
    let acronym = matches.join("").toUpperCase();
    return acronym.substring(0, 2);
  }
}

export {
  removeNullAttributes,
  queryStringFromObject,
  getDataFromToken,
  getKeyByValue,
  isObjectEmpty,
  dateDifference,
  getFirstLetters,
};
